import { Provider } from 'react-redux';
import './App.css';
import { store } from './store';
import AppRouter from './routes/AppRouter';
import { ThemeProvider } from '@emotion/react';
import theme from './utils/theme';
import { Toaster } from 'react-hot-toast';
import BrandOverlay from './components/BrandOverlay';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AppRouter/>
        <Toaster/>
        <BrandOverlay 
            text="Made by UOC Tech"
            link="https://www.facebook.com/uoctech"
            opacity={0.3}
            fontSize="13px"
            color="#333333"
            position="bottom-left"
            // hideOnMobile={true}
        />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
